import React from 'react';

function About() {
  return (
    <div className="about-page bg-white text-gray-900 px-6 md:px-12 lg:px-24 py-16">
      <section className="banner_section_padding">
        <div className="lg_wraperr">
          <h1 className="spacing">Hi, I’m Aryan. Full Stack Power. HubSpot Flexibility.</h1>
          <div className="row-fluid sec_cent spacing">
            {/* Image section */}
            <div className="span6 Image_box">
              <div className="about_image">
              <img
                src="/Images/About.jpg"
                alt="Profile"
              />
              </div>
            </div>

            {/* Intro section */}
            <div className="span6 intro_box">
              <h4>I am a Full Stack Engineer & HubSpot Specialist bridging the gap between complex backend
                 logic and pixel-perfect design.</h4>
              <h4>
                 With over 3 years of experience, I don’t just write code—I build platforms that scale.
                 My expertise lies in architecting high-performance e-commerce applications using Next.js 
                 and the MERN stack, and developing enterprise-grade custom themes for the HubSpot CMS. I 
                 focus on speed, SEO, and creating seamless user experiences that drive revenue.
              </h4>
            </div>
          </div>

          <div className="row-fluid sec_cent">
            <div className="span6">
              <h4>The Engineer</h4>
                <p>
                  I specialize in building "headless" architectures that load instantly. By leveraging Next.js,
                   Node.js, and MongoDB, I create custom web applications that handle complex data without compromising 
                   on speed. For marketing teams, I push the boundaries of HubSpot, writing custom HubL and JavaScript
                    to build themes that are 100% editable and distinct from generic templates.
                </p>
            </div>
            <div className="span6">
              <h4>The Business Partner</h4>
              <p>
                I believe code should serve a business purpose. Whether I’m optimizing Core Web Vitals to 
                boost your SEO rankings or streamlining your content management workflow, my goal is always
                 ROI. Currently pursuing an MBA in IT, I bring a strategic mindset to development—ensuring every
                  line of code contributes to your bottom line.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="my_approach_section section_padding">
        <div className="wrapper">
          <h2 className="align_center mb-10">My Approach</h2>

          <div className="approach_grid">

            {/* 1️⃣ Performance First */}
            <div className="approach_card">
              <span className="approach_icon">⚡</span>
              <h3>Performance First</h3>
              <p>
                I build websites that consistently score 95+ on Google PageSpeed. 
                Faster sites rank better, convert more users, and improve overall UX.
              </p>
            </div>

            {/* 2️⃣ Scalable Architecture */}
            <div className="approach_card">
              <span className="approach_icon">🛠️</span>
              <h3>Scalable Architecture</h3>
              <p>
                I write clean, modular, and scalable code — whether it's React, Node, 
                or HubSpot CMS — ensuring your product grows without technical debt.
              </p>
            </div>

            {/* 3️⃣ Clear Communication */}
            <div className="approach_card">
              <span className="approach_icon">🤝</span>
              <h3>Clear Communication</h3>
              <p>
                I share clear updates, avoid jargon, and translate technical decisions 
                into business outcomes so teams move faster together.
              </p>
            </div>

          </div>
        </div>
      </section>


      {/* CTA section */}
      <section className="cta_section section_padding bg_dark all_text_white align_center">
            <div className="md_wrapper">
                <h2>Like what you see?</h2>
                <p>Explore more of my work or download my resume to get in touch.</p>
                <div className="buttons_container">
                <a href="/projects" className="cta_button White">
                    Explore more
                </a>
                <a href="https://drive.google.com/file/d/1H9crBoHWFWySRgASzmO_xQ9U6JuFnbQd/view?usp=drivesdk" className="cta_button white border">
                    Download resume
                </a>
                </div>
            </div>
      </section>
    </div>
  );
}

export default About;
